module.exports = __webpack_public_path__ + "img/fachadaeliza3.b3a812f5.png";